class ContactForm {

    // ─── PAISES ──────────────────────────────────────────────────────────────
    static COUNTRIES = [
        { name: 'España', iso: 'ES', prefix: '+34' },
        { name: 'Andorra', iso: 'AD', prefix: '+376' },
        { name: 'Alemania', iso: 'DE', prefix: '+49' },
        { name: 'Arabia Saudita', iso: 'SA', prefix: '+966' },
        { name: 'Argentina', iso: 'AR', prefix: '+54' },
        { name: 'Australia', iso: 'AU', prefix: '+61' },
        { name: 'Austria', iso: 'AT', prefix: '+43' },
        { name: 'Bélgica', iso: 'BE', prefix: '+32' },
        { name: 'Bolivia', iso: 'BO', prefix: '+591' },
        { name: 'Brasil', iso: 'BR', prefix: '+55' },
        { name: 'Canadá', iso: 'CA', prefix: '+1' },
        { name: 'Chile', iso: 'CL', prefix: '+56' },
        { name: 'China', iso: 'CN', prefix: '+86' },
        { name: 'Colombia', iso: 'CO', prefix: '+57' },
        { name: 'Corea del Sur', iso: 'KR', prefix: '+82' },
        { name: 'Costa Rica', iso: 'CR', prefix: '+506' },
        { name: 'Cuba', iso: 'CU', prefix: '+53' },
        { name: 'Dinamarca', iso: 'DK', prefix: '+45' },
        { name: 'Ecuador', iso: 'EC', prefix: '+593' },
        { name: 'Egipto', iso: 'EG', prefix: '+20' },
        { name: 'El Salvador', iso: 'SV', prefix: '+503' },
        { name: 'Emiratos Arabes', iso: 'AE', prefix: '+971' },
        { name: 'Eslovaquia', iso: 'SK', prefix: '+421' },
        { name: 'Eslovenia', iso: 'SI', prefix: '+386' },
        { name: 'Estonia', iso: 'EE', prefix: '+372' },
        { name: 'Filipinas', iso: 'PH', prefix: '+63' },
        { name: 'Finlandia', iso: 'FI', prefix: '+358' },
        { name: 'Francia', iso: 'FR', prefix: '+33' },
        { name: 'Georgia', iso: 'GE', prefix: '+995' },
        { name: 'Ghana', iso: 'GH', prefix: '+233' },
        { name: 'Grecia', iso: 'GR', prefix: '+30' },
        { name: 'Guatemala', iso: 'GT', prefix: '+502' },
        { name: 'Honduras', iso: 'HN', prefix: '+504' },
        { name: 'Hong Kong', iso: 'HK', prefix: '+852' },
        { name: 'Hungria', iso: 'HU', prefix: '+36' },
        { name: 'India', iso: 'IN', prefix: '+91' },
        { name: 'Indonesia', iso: 'ID', prefix: '+62' },
        { name: 'Irlanda', iso: 'IE', prefix: '+353' },
        { name: 'Israel', iso: 'IL', prefix: '+972' },
        { name: 'Italia', iso: 'IT', prefix: '+39' },
        { name: 'Jamaica', iso: 'JM', prefix: '+1876' },
        { name: 'Japón', iso: 'JP', prefix: '+81' },
        { name: 'Jordania', iso: 'JO', prefix: '+962' },
        { name: 'Kuwait', iso: 'KW', prefix: '+965' },
        { name: 'Letonia', iso: 'LV', prefix: '+371' },
        { name: 'Líbano', iso: 'LB', prefix: '+961' },
        { name: 'Lituania', iso: 'LT', prefix: '+370' },
        { name: 'Luxemburgo', iso: 'LU', prefix: '+352' },
        { name: 'Malasia', iso: 'MY', prefix: '+60' },
        { name: 'Marruecos', iso: 'MA', prefix: '+212' },
        { name: 'México', iso: 'MX', prefix: '+52' },
        { name: 'Nicaragua', iso: 'NI', prefix: '+505' },
        { name: 'Nigeria', iso: 'NG', prefix: '+234' },
        { name: 'Noruega', iso: 'NO', prefix: '+47' },
        { name: 'Nueva Zelanda', iso: 'NZ', prefix: '+64' },
        { name: 'Países Bajos', iso: 'NL', prefix: '+31' },
        { name: 'Panamá', iso: 'PA', prefix: '+507' },
        { name: 'Paraguay', iso: 'PY', prefix: '+595' },
        { name: 'Perú', iso: 'PE', prefix: '+51' },
        { name: 'Polonia', iso: 'PL', prefix: '+48' },
        { name: 'Portugal', iso: 'PT', prefix: '+351' },
        { name: 'Puerto Rico', iso: 'PR', prefix: '+1787' },
        { name: 'Qatar', iso: 'QA', prefix: '+974' },
        { name: 'Reino Unido', iso: 'GB', prefix: '+44' },
        { name: 'República Checa', iso: 'CZ', prefix: '+420' },
        { name: 'República Dominicana', iso: 'DO', prefix: '+1809' },
        { name: 'Rumanía', iso: 'RO', prefix: '+40' },
        { name: 'Rusia', iso: 'RU', prefix: '+7' },
        { name: 'Senegal', iso: 'SN', prefix: '+221' },
        { name: 'Serbia', iso: 'RS', prefix: '+381' },
        { name: 'Singapur', iso: 'SG', prefix: '+65' },
        { name: 'Sudáfrica', iso: 'ZA', prefix: '+27' },
        { name: 'Suecia', iso: 'SE', prefix: '+46' },
        { name: 'Suiza', iso: 'CH', prefix: '+41' },
        { name: 'Tailandia', iso: 'TH', prefix: '+66' },
        { name: 'Taiwán', iso: 'TW', prefix: '+886' },
        { name: 'Turquía', iso: 'TR', prefix: '+90' },
        { name: 'Ucrania', iso: 'UA', prefix: '+380' },
        { name: 'Uruguay', iso: 'UY', prefix: '+598' },
        { name: 'USA', iso: 'US', prefix: '+1' },
        { name: 'Venezuela', iso: 'VE', prefix: '+58' },
        { name: 'Vietnam', iso: 'VN', prefix: '+84' },
    ];

    /**
     * @param {HTMLElement} root - Contenedor .wpcf7 del formulario CF7
     */
    constructor(root) {
        console.log('Initializing ContactForm for', root);

        this.root = root;
        this.phoneSelect = root.querySelector('#pais_selector');
        this.phonePrefix = root.querySelector('#phone_prefix');
        this.phoneInput = root.querySelector('#phone_number');
        this.hiddenPhone = root.querySelector('#telefono_completo');
        this.dormButtons = root.querySelectorAll('.cf-dormitorios__btn');
        this.hiddenDorm = root.querySelector('#dormitorios');
        this.postalInput = root.querySelector('#codigo_postal');
        this.submitRow = root.querySelector('.cf-form__submit-row');
        this.cols = root.querySelectorAll('.cf-form__col');

        this._initPhone();
        this._initDormitorios();
        this._initPostalCode();
        this._initResponsiveSubmit();
    }

    // ─── TELÉFONO ─────────────────────────────────────────────────────────────

    _initPhone() {
        if (!this.phoneSelect || !this.phonePrefix || !this.phoneInput || !this.hiddenPhone) return;

        ContactForm.COUNTRIES.forEach(({ name, iso, prefix }) => {
            const option = document.createElement('option');
            option.value = iso;
            option.dataset.prefix = prefix;
            option.textContent = name;
            if (iso === 'ES') option.selected = true;
            this.phoneSelect.appendChild(option);
        });

        this._updatePhone();
        this.phoneSelect.addEventListener('change', () => this._updatePhone());
        this.phoneInput.addEventListener('input', () => this._updatePhone());
    }

    _updatePhone() {
        const selected = this.phoneSelect.options[this.phoneSelect.selectedIndex];
        const prefix = selected ? selected.dataset.prefix : '+34';
        this.phonePrefix.textContent = prefix;
        const raw = this.phoneInput.value.trim();
        this.hiddenPhone.value = raw ? `${prefix} ${raw}` : '';
    }

    // ─── DORMITORIOS ──────────────────────────────────────────────────────────

    _initDormitorios() {
        if (!this.dormButtons.length || !this.hiddenDorm) return;

        this.dormButtons.forEach(btn => {
            btn.addEventListener('click', () => {
                this.dormButtons.forEach(b => {
                    b.classList.remove('is-active');
                    b.setAttribute('aria-pressed', 'false');
                });
                btn.classList.add('is-active');
                btn.setAttribute('aria-pressed', 'true');
                this.hiddenDorm.value = btn.dataset.value ?? '';
            });
        });
    }

    // ─── CÓDIGO POSTAL ────────────────────────────────────────────────────────

    _initPostalCode() {
        if (!this.postalInput) return;

        this.postalInput.addEventListener('input', function () {
            this.value = this.value.replace(/\D/g, '').slice(0, 5);
        });
    }

    // ─── SUBMIT RESPONSIVE ───────────────────────────────────────────────────

    _initResponsiveSubmit() {
        if (!this.submitRow || this.cols.length < 2) return;

        const secondCol = this.cols[1];
        const originalParent = this.submitRow.parentElement;
        const originalNextSibling = this.submitRow.nextSibling;

        const mq = window.matchMedia('(max-width: 767px)');

        const handleChange = (e) => {
            if (e.matches) {
                secondCol.appendChild(this.submitRow);
            } else {
                originalParent.insertBefore(this.submitRow, originalNextSibling);
            }
        };

        mq.addEventListener('change', handleChange);
        handleChange(mq);
    }

    // ─── INIT ESTÁTICO ────────────────────────────────────────────────────────

    static init() {
        document.querySelectorAll('.wpcf7').forEach(wrapper => {
            new ContactForm(wrapper);
        });
    }
}

export default () => ContactForm.init();